import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-status-filter',
  templateUrl: './status-filter.component.html',
  styleUrls: ['./status-filter.component.scss'],
})
export class StatusFilterComponent {
  @Input() statusOptions: any[] = [];
  @Input() selectedStatus: any[] = [];
  @Input() willClearSelected: boolean = false;
  @Input() label: string = 'Filtrar por Status';
  @Input() showColorIcon: boolean = true;
  @Output() statusSelected = new EventEmitter<any>();
  @ViewChild('statusFilterPopover') popover!: HTMLIonPopoverElement;

  isOpen = false;

  ngOnInit() {
    if (this.selectedStatus.length) {
      this.statusSelected.emit(this.selectedStatus);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['willClearSelected'] &&
      !changes['willClearSelected'].firstChange
    ) {
      if (this.willClearSelected) this.selectedStatus = [];
    }
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  selectStatus(option: any) {
    if (this.isSelected(option.id)) {
      this.selectedStatus = this.selectedStatus.filter(
        (status) => status.id !== option.id,
      );
    } else {
      this.selectedStatus.push(option);
    }
    this.statusSelected.emit(this.selectedStatus);
    this.isOpen = false;
  }

  clearStatus(event: Event) {
    event.stopPropagation();
    this.selectedStatus = [];
    this.statusSelected.emit([]);
    this.isOpen = false;
  }

  isSelected(statusId: string): boolean {
    return this.selectedStatus.some((status) => status.id === statusId);
  }
}
